import {
  getNotificationRules,
  postNotificationRule,
  deleteNotificationRule
} from './util';

export const FETCH_NOTIFICATION_RULES_REQUEST = 'FETCH_NOTIFICATION_RULES_REQUEST';
export const FETCH_NOTIFICATION_RULES_SUCCESS = 'FETCH_NOTIFICATION_RULES_SUCCESS';
export const FETCH_NOTIFICATION_RULES_FAILURE = 'FETCH_NOTIFICATION_RULES_FAILURE';

export const POST_NOTIFICATION_RULE_REQUEST = 'POST_NOTIFICATION_RULE_REQUEST';
export const POST_NOTIFICATION_RULE_SUCCESS = 'POST_NOTIFICATION_RULE_SUCCESS';
export const POST_NOTIFICATION_RULE_FAILURE = 'POST_NOTIFICATION_RULE_FAILURE';

export const DELETE_NOTIFICATION_RULE_REQUEST = 'DELETE_NOTIFICATION_RULE_REQUEST';
export const DELETE_NOTIFICATION_RULE_SUCCESS = 'DELETE_NOTIFICATION_RULE_SUCCESS';
export const DELETE_NOTIFICATION_RULE_FAILURE = 'DELETE_NOTIFICATION_RULE_FAILURE';

const fetchtNotificationRulesRequest = () => ({
  type: FETCH_NOTIFICATION_RULES_REQUEST
});
const fetchNotificationRulesSuccess = notificationRules => ({
  type: FETCH_NOTIFICATION_RULES_SUCCESS,
  payload: notificationRules
});
const fetchNotificationRulesFailure = error => ({
  type: FETCH_NOTIFICATION_RULES_FAILURE,
  payload: error
});
const postNotificationRuleRequest = () => ({
  type: POST_NOTIFICATION_RULE_REQUEST
});
const postNotificationRuleSuccess = notificationRule => ({
  type: POST_NOTIFICATION_RULE_SUCCESS,
  payload: notificationRule
});
const postNotificationRuleFailure = error => ({
  type: POST_NOTIFICATION_RULE_FAILURE,
  payload: error
});
const deleteNotificationRuleRequest = () => ({
  type: DELETE_NOTIFICATION_RULE_REQUEST
});
const deleteNotificationRuleSuccess = notificationRule => ({
  type: DELETE_NOTIFICATION_RULE_SUCCESS,
  payload: notificationRule
});
const deleteNotificationRuleFailure = error => ({
  type: DELETE_NOTIFICATION_RULE_FAILURE,
  payload: error
});

export const fetchNotificationRules = user => async (dispatch) => {
  try {
    dispatch(fetchtNotificationRulesRequest());
    const response = await getNotificationRules(user);
    if (response.status === 200) {
      dispatch(fetchNotificationRulesSuccess(response.data.notification_rules));
    } else {
      throw response;
    }
  } catch {
    const error = { code: 500, message: 'Internal Server Error' };
    dispatch(fetchNotificationRulesFailure(error));
  }
};

export const createNotificationRule = (user, contactType) => async (dispatch, getStore) => {
  try {
    dispatch(postNotificationRuleRequest());
    const contactMethod = getStore().contactMethods.selected[contactType];
    const response = await postNotificationRule(user, contactMethod);

    if (response.status === 201) {
      const notificationRule = response.data.notification_rule;
      dispatch(postNotificationRuleSuccess(notificationRule));
    } else {
      throw response;
    }
  } catch {
    const error = { code: 500, message: 'Internal Server Error' };
    dispatch(postNotificationRuleFailure(error));
  }
};

export const deleteImmediateNotificationRules = user => async (dispatch, getState) => {
  const cachedRules = getState().notificationRules.rules;
  const rulesToDelete = cachedRules.filter(rule => rule.start_delay_in_minutes === 0);

  await rulesToDelete.forEach(async (rule) => {
    try {
      dispatch(deleteNotificationRuleRequest());
      const response = await deleteNotificationRule(user, rule);
      if (response.status === 204) {
        dispatch(deleteNotificationRuleSuccess(rule));
      } else {
        throw response;
      }
    } catch {
      const error = { code: 500, message: 'Internal Server Error' };
      dispatch(deleteNotificationRuleFailure(error));
    }
  });
};
